import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 12h-6h1a3 3 0 0 1 0 6h-1l3 3","key":"svg-0"}],["path",{"d":"M15 15h6","key":"svg-1"}],["path",{"d":"M3 5a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-2"}],["path",{"d":"M15 5a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-3"}],["path",{"d":"M7 5h8","key":"svg-4"}],["path",{"d":"M7 5v8a3 3 0 0 0 3 3h1","key":"svg-5"}]]

const IconTransactionRupee = createReactComponent('outline', 'transaction-rupee', 'TransactionRupee', __iconNode);

export default IconTransactionRupee;